/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Page_OnlyInputs */

const en_common_page_only = /** @type {(inputs: Common_Page_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Only`)
};

const es_common_page_only = /** @type {(inputs: Common_Page_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo página`)
};

/**
* | output |
* | --- |
* | "Page Only" |
*
* @param {Common_Page_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_page_only = /** @type {((inputs?: Common_Page_OnlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Page_OnlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_page_only(inputs)
	return en_common_page_only(inputs)
});